<a
  [routerLink]="
    productCardData()?._id ? '/products/' + productCardData()?._id : ''
  "
  class="product-card">
  <!-- product card header -->
  <div class="product-card__header">
    <!-- product title -->
    <h3 class="product-card__title">
      <pwj-text-summarizer
        [text]="productCardData()?.title || '-' | translateData"
        [limitLength]="22">
      </pwj-text-summarizer>
    </h3>
    <!-- product grade -->
    @if (productCardData()?.stone_grade) {
      <p class="product-card__grade">
        <span class="grade-text">
          {{ 'enums.grades.' + productCardData()?.stone_grade | translate }}
        </span>
      </p>
    }
  </div>
  <!-- product card body -->
  <div class="product-card__body">
    <div class="product-card__image-container">
      <!-- product card image -->
      <img
        class="product-card__image"
        [ngSrc]="
          productCardData()?.main_photo?.cropped_url?.toLowerCase() ||
            productCardData()?.images?.[0]?.cropped_url?.toLowerCase() ||
            productCardData()?.images?.[0]?.url | imageSource
        "
        [width]="268"
        [height]="268"
        [alt]="(productCardData().title | translateData) || 'product image'" />

      <!-- product card favorite button -->
      @if (isFavoriteMode()) {
        <button
          class="product-card__favorite-button"
          (click)="removeProductFromFavorite($event)">
          <img
            class="product-card__favorite-icon"
            ngSrc="assets/icons/heart.svg"
            width="30"
            height="30"
            alt="favorite" />
        </button>
      }
      <!-- product card code -->
      <div class="product-card__code">
        {{ productCardData()?.code }}
      </div>
    </div>

    <!-- product supplier -->
    <div class="product-card__supplier">
      <!-- company info -->
      <pwj-card-title
        class="product-card__supplier-title"
        [cardTitleData]="cardTitleData"></pwj-card-title>

      <!-- country flag -->
      @if (productCardData().business) {
        <div class="product-card__supplier-flag">
          <i
            [class]="
              'flag-icon flags flag:' + productCardData()?.origin_country?.iso
            "></i>
        </div>
      }
    </div>
  </div>
  <!-- product card footer -->
  <div class="product-card__footer">
    <!-- product price -->
    <div class="product-card__price">
      <p class="price-label">{{ 'products.priceRange' | translate }}</p>
      <pwj-item-prices
        [highestPrice]="productCardData()?.highest_price"
        [lowestPrice]="productCardData()?.lowest_price"></pwj-item-prices>
    </div>
  </div>
</a>
